__turbopack_context__.v({
  "pill": "NotificationToolbar-module-scss-module__vyjl8W__pill",
});
